import { isEmpty } from 'lodash';

import { Heading } from '@/components/heading';
import { ShipmentMeta } from '@/lib/models/shipment/types';
import { tv } from '@/utils/styles';

export interface ShipmentMetaSummaryProps {
  shipmentMeta: ShipmentMeta;
}

const ShipmentMetaSummary = ({ shipmentMeta }: ShipmentMetaSummaryProps) => {
  const { skus, purchaseOrders } = shipmentMeta;

  const { base, heading, detail } = styles();
  return (
    <aside className={base()}>
      {!isEmpty(purchaseOrders) ? (
        <div>
          <div>
            <Heading className={heading()} as="h3">
              Purchase orders
            </Heading>
          </div>
          <ul>
            {purchaseOrders?.map((purchaseOrder, i) => {
              return (
                <li key={i} className={detail()}>
                  {purchaseOrder}
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
      {!isEmpty(skus) ? (
        <div>
          <div>
            <Heading className={heading()} as="h3">
              SKUs
            </Heading>
          </div>
          <ul>
            {skus?.map((sku, i) => {
              return (
                <li key={i} className={detail()}>
                  {sku}
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </aside>
  );
};

const styles = tv({
  slots: {
    base: 'flex flex-col gap-y-4 rounded border border-grey-300 bg-white p-4 @container/vessel-summary',
    heading: 'm-0 !text-sm font-normal text-text-secondary',
    detail: 'm-0 text-sm text-text-primary',
  },
});

export { ShipmentMetaSummary };
